import { useContext, useEffect } from "react";
import { toast } from "react-toastify";
import { SocketContext } from "../../context/Socket/SocketContext";
import { AuthContext } from "../../context/Auth/AuthContext";

/**
 * Aviso en vivo a los ADMINISTRADORES cuando un webhook o la IA de un flujo lleva varios fallos
 * seguidos (0422 R5). El backend solo lo emite a sus salas de usuario, como mucho una vez cada
 * 6 h por nodo; la lista de flujos lo sigue marcando mientras dure.
 */
const FlowAlertsListener = () => {
  const socketManager = useContext(SocketContext);
  const { user } = useContext(AuthContext);

  useEffect(() => {
    if (!user?.companyId || user?.profile !== "admin") return () => {};
    const socket = socketManager.getSocket(String(user.companyId));
    if (!socket) return () => {};
    const evento = `company-${user.companyId}-flow-alert`;
    const alRecibir = (a) => {
      const que = a?.kind === "openai" ? "la IA" : "el webhook";
      toast.warn(
        `⚠️ Flujo «${a?.flowName}»: ${que} lleva ${a?.failCount} fallos seguidos` +
          (a?.lastError ? ` (${String(a.lastError).slice(0, 120)})` : "") +
          ". Revísalo en Flujos.",
        { autoClose: false }
      );
    };
    socket.on(evento, alRecibir);
    return () => socket.off(evento, alRecibir);
  }, [socketManager, user?.companyId, user?.profile]);

  return null;
};

export default FlowAlertsListener;
